"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=e(require("react"));exports.RenderHtml=({htmlData:e})=>t.default.createElement("div",{dangerouslySetInnerHTML:{__html:e},"data-testid":"render-html-container"});
//# sourceMappingURL=RenderHtml-Dlnu0Eyb.js.map
